module.exports = __webpack_public_path__ + "assets/img/tenantsHeaderIcon.4cc49208.svg";